import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app/App/App'
import { Provider } from 'react-redux'
import useErrorPageStore from './pages/duty/ErrorPage/zustand/store'
import store from './parts/store'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/browser'
import ErrorPage from './pages/duty/ErrorPage/ErrorPage'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from 'react-query'
import { queryClient } from './parts/requests/queryClient'
import { reloadOnceOnChunkError } from './parts/utils/chunkLoadError'
import Loader from './ui/Loader/Loader'
import './parts/i18n/config'

const handleErrorBoundaryFallback = ({ error }: { error: Error }) => {
	if (reloadOnceOnChunkError(error)) {
		return <Loader />
	}

	return <ErrorPage errorCode={500} />
}

Sentry.init({
	// process.env.SENTRY_DSN
	dsn: 'https://4711fb4ce9923c1171b89f06f0f79d35@sentry.credu.ai/7',
	integrations: [new BrowserTracing()],
	tracesSampleRate: 0.1,
	environment: process.env.REACT_APP_ENV,
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
	<QueryClientProvider client={queryClient}>
		<Provider store={store}>
			<BrowserRouter>
				<Sentry.ErrorBoundary
					fallback={handleErrorBoundaryFallback}
					onError={(error) => {
						if (reloadOnceOnChunkError(error)) {
							return
						}

						useErrorPageStore.getState().updateStore({ error })
					}}
				>
					<App />
				</Sentry.ErrorBoundary>
			</BrowserRouter>
		</Provider>
	</QueryClientProvider>
)
